import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountLogo,
  AccountLogoAccent,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';
import ResForm from '@/shared/components/account/AddResForm/ResForm';
import { SignInLogo } from '../../Layout/components/topbar/BasicTopbarComponents';
import { GlobalVarContext } from '../../../context/GlobalVarContext';
import { RestaurantContext } from '../../../context/RestaurantContext';

const auth0Icon = `${process.env.PUBLIC_URL}/img/auth0.svg`;

const Form = () => {
  const [checkedTandC, setCheckedTandC] = useState(false);
  const {
    setRefresh,
     setShowModal,
     } = useContext(RestaurantContext);
  const { apiGlobal } = useContext(GlobalVarContext);

     const history = useHistory();

     

  const handleSubmit = async (value) => {
   // console.log(JSON.stringify(value, null, 2));
    if (String(value.accountNo) !== String(value.conAccount)) {
      toast.error('Account number Do not match. Please Check and try again.');
      return;
  }

   if (!value.country) {
    toast.error('Please select your country.');
    return;
  }

  if (!value.accCountry) {
    toast.error('Please select account country.');
    return;
  }

  if (!value.countryCode) {
    toast.error('Please select a country code.');
    return;
  }
 
  
    const formData = new FormData();
    formData.append('user_name', value.userName);
    formData.append('user_phone', value.userPhone);
    formData.append('user_email', value.userEmail);
    formData.append('country_code', value.countryCode.value);
    formData.append('uin', value.uin);
    formData.append('photo', value.file); // Ensure value.file exists
    formData.append('country', value.country.value);
    formData.append('acc_name', value.accName);
    formData.append('acc_country', value.accCountry.value);
    formData.append('account_no', value.accountNo);
    formData.append('acc_city', value.accCity);
    formData.append('con_account', value.conAccount);
    formData.append('branch', value.branch);
    formData.append('ifsc_code', value.ifscCode);
    formData.append('bank', value.bank);
    formData.append('type', '1');
    formData.append('tc', checkedTandC ? '1' : '0');

    // for log form Data
    formData.forEach((values, key) => {
      console.log(`${key}: ${values}`);
     });

    try {
      const response = await fetch(`${apiGlobal}/restaurant_add.php`, {
          method: 'POST',
          body: formData,
      });

      // console.log(response);

      if (!response.ok) {
        throw new Error('Network response was not ok');
    }
      const responseData = await response.json();
      // console.log(responseData);
      if (responseData.status && responseData.message === 'Data inserted successfully.') {
          toast.success('Restaurant Added Successfully...');
          setTimeout(() => {
            toast.success('Redirect to log In');
            history.push('/');
          }, 1500);
      } else {
          toast.error(responseData.message);
      }
  } catch (error) {
      toast.error(error.message);
      console.log(error);
  }    
  };
  return (

    <ResForm 
      form="/res_form" 
      onSubmit={handleSubmit}
      checkedTandC={checkedTandC}
      setCheckedTandC={setCheckedTandC}
    />
      
    );
};

// LogIn.propTypes = {
//   changeIsOpenModalFireBase: PropTypes.func.isRequired,
// };

export default Form;
